<template>
  <div :class="{'side__card': !$vuetify.breakpoint.xs} ||!$vuetify.breakpoint.sm">
      <v-list dense>
        <v-list-item
            v-for="(item, i) in filteredLinks"
            :key="i"
            :to="item.link"
            :disabled="!item.link"
        >
         <v-list-item-icon >
            <v-icon color="primary">{{item.icon}}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title v-text="item.text"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </div>
</template>
<script>
import {mapGetters} from "vuex";

export default {
  name: "ProfileSideBar",
  data: () => ({
    isMentorAccount:false,
    links: [
      {text: 'Edit Profile', link: '/profile', icon: 'mdi-pencil',access:'ALL'},
      {text: 'Documents',link: '/documents',  icon: 'mdi-file-document-multiple',access:'MENTOR'},
      {text: 'Change Password',link: '/change_password', icon: 'mdi-lock',access:'ALL'},
    ]
  }),
  beforeMount() {
    this.isMentorAccount = this.user.account_types?.filter(item => item.name.toUpperCase() === "MENTOR").length > 0
  },
  computed: {
    ...mapGetters({
      user: "auth/GET_USER",
    }),
    filteredLinks(){
      if(this.isMentorAccount){
        return this.links
      }
      return this.links.filter((x)=> {return x.access != 'MENTOR'})
    }
  },
}
</script>

<style scoped>

.side__card {
  margin-top: 10px;
}
</style>

